<cdk-accordion-item #accordionItem="cdkAccordionItem" role="button" tabindex="0" [expanded]="true">
  <section class="px-5" [formGroup]="licenseAgreementForm">
    <div (click)="accordionItem.toggle()">
      <div class="relative flex items-center">
        <svg-icon
          class="max-h-6 max-w-6"
          size="md"
          [key]="licenseAgreementForm.controls.practice.valid ? 'px-24-agreement-icon-valid' : 'px-24-agreement-icon-invalid'"
        ></svg-icon>
        <span class="ml-2 text-[15px] font-medium leading-tight">{{ 'site_setup_practice_provide_details' | translate }}</span>
        <svg-icon
          class="absolute right-0 text-text-tertiary"
          [key]="accordionItem.expanded ? 'px-24-arrow-up' : 'px-24-arrow-down'"
        ></svg-icon>
      </div>
    </div>
    <div formGroupName="practice" class="mt-5 grid gap-5" role="region" [style.display]="accordionItem.expanded ? '' : 'none'">
      <lib-input
        background="white"
        size="large"
        [label]="'site_setup_practice_legal_name_placeholder' | translate"
        formControlName="legalName"
        [hint]="
          this.vm().isFormSubmitted && practiceControls.legalName.invalid
            ? ('site_setup_form_required' | translate)
            : ('site_setup_practice_legal_name_hint' | translate)
        "
        [state]="this.vm().isFormSubmitted && practiceControls.legalName.invalid ? 'error' : 'normal'"
      ></lib-input>
      <lib-dropdown
        background="white"
        [label]="'site_setup_practice_country_region_placeholder' | translate"
        size="large"
        [options]="[
          {
            value: 'USA',
            label: 'site_setup_practice_country_region_option_usa' | translate
          }
        ]"
        formControlName="country"
        [hint]="this.vm().isFormSubmitted && practiceControls.country.invalid ? ('site_setup_form_required' | translate) : ''"
        [error]="this.vm().isFormSubmitted && practiceControls.country.invalid"
      ></lib-dropdown>
      <lib-input
        background="white"
        size="large"
        [label]="'site_setup_practice_street_address_placeholder' | translate"
        formControlName="address"
        [hint]="this.vm().isFormSubmitted && practiceControls.address.invalid ? ('site_setup_form_required' | translate) : ''"
        [state]="this.vm().isFormSubmitted && practiceControls.address.invalid ? 'error' : 'normal'"
      ></lib-input>
      <lib-input
        background="white"
        size="large"
        [label]="'site_setup_practice_city_placeholder' | translate"
        formControlName="city"
        [hint]="this.vm().isFormSubmitted && practiceControls.city.invalid ? ('site_setup_form_required' | translate) : ''"
        [state]="this.vm().isFormSubmitted && practiceControls.city.invalid ? 'error' : 'normal'"
      ></lib-input>
      <div class="flex w-full gap-3">
        <lib-dropdown-search
          class="w-1/2"
          size="large"
          formControlName="state"
          [label]="'site_setup_practice_state_placeholder' | translate"
          [options]="statesDropdownOptions"
          [hint]="this.vm().isFormSubmitted && practiceControls.state.invalid ? ('site_setup_form_required' | translate) : ''"
          [state]="this.vm().isFormSubmitted && practiceControls.state.invalid ? 'error' : 'normal'"
        ></lib-dropdown-search>

        <lib-input
          background="white"
          class="!w-1/2"
          size="large"
          [label]="'site_setup_practice_zip_placeholder' | translate"
          formControlName="zip"
          [hint]="this.vm().isFormSubmitted && practiceControls.zip.invalid ? ('site_setup_form_required' | translate) : ''"
          [state]="this.vm().isFormSubmitted && practiceControls.zip.invalid ? 'error' : 'normal'"
        ></lib-input>
      </div>
    </div>
  </section>
</cdk-accordion-item>
